import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

import { authProvider } from "authProvider";

export default {
  title: "Sconti minorenni",
  resource: "age-ranges",
  canCreate: true,
  customDataGetter: async () => {
    let user = await authProvider.getUserIdentity();
    return user.id;
  },
  dataGridParams: (cData) => {
    //cData in this case will contain user ID
    return {
      permanentFilter: [
        {
          field: "struttura.owner.id",
          operator: "eq",
          value: cData,
        },
      ],
    };
  },
  columns: [
    { field: "min", headerName: "Età minima", flex: 1, minWidth: 150 },
    { field: "max", headerName: "Età massima", flex: 1, minWidth: 150 },
    {
      field: "discount",
      headerName: "Sconto",
      valueGetter: ({ row }) => {
        const value = row?.discount;
        const symbol = row?.discount_type == "percent" ? "%" : "€";
        return `${value} ${symbol}`;
      },
      flex: 1,
      minWidth: 300,
    },
    { field: "from", headerName: "Valido dal", flex: 1, minWidth: 200 },
    { field: "to", headerName: "Valido fino al", flex: 1, minWidth: 200 },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 150,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
